import React from 'react'

import {
	WrapUpSectionLabel,
	WrapUpSectionContainer,
	WrapUpStatement,
	Item,
} from './WrapUpSectionComponents'

import { graphql } from 'gatsby'

const Takeaways = ({ takeaways }) => {
	if (!takeaways?.length) return null

	const { statement, takeaways: items, numbered } = takeaways[0]
	return (
		<WrapUpSectionContainer>
			<WrapUpSectionLabel>Takeaways</WrapUpSectionLabel>
			{statement !== null && <WrapUpStatement>{statement.statement}</WrapUpStatement>}

			{items.map((t, i) => (
				<Item key={t.raw} i={i + 1} numbered={numbered} {...t} />
			))}
		</WrapUpSectionContainer>
	)
}

export default Takeaways

export const query = graphql`
	fragment Takeaways on ContentfulArticle {
		takeaways {
			statement {
				statement
			}
			numbered
			takeaways {
				headlineContent {
					raw
				}
				copyContent {
					raw
				}
			}
		}
	}
`
